const DateToDateString = (date) => {
  const days = date.getDate().toString().padStart(2, "0");
  const months = (date.getMonth() + 1).toString().padStart(2, "0");
  return `${days}/${months}/${date.getFullYear()}`;
};
const DateToDateTimeString = (date) =>
  `${DateToDateString()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

  const serverURL = process.env.REACT_APP_SERVER_URL || `http://localhost:5000`;
  const PRODUCTION = serverURL !== `http://localhost:5000`;

  

export { DateToDateString, DateToDateTimeString, serverURL, PRODUCTION };
